import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SELLERS_ROUTE } from '../shared/constants/routes';
import { SellersComponent } from './sellers/sellers.component';
import { AuthGuard } from '../guards/auth.guard';

const routes: Routes = [
  {
    path: SELLERS_ROUTE,
    component: SellersComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SellersRoutingModule {}
